import React from "react";

const NavBarWithoutLogo: React.FC = () => {

  const Logo = "/documents/d/guest/Frame_2"; 
  const Person = "/documents/d/guest/Frame-1";

  return (
    <div className="menu_cont is-menu-blanco">
      <a href={"/"} className="menu_link-logo is-blanco w-nav-brand">
        <img
          loading="lazy"
          src={Logo}
          alt=""
          className="menu_logo is-medium is-blanco"
        />
      </a>
      <nav role="navigation" className="menu_links w-nav-menu">
        <div className="menu_link-content is-hide">
          <a href="#" className="menu_item is-black w-nav-link">
            Mis seguros2
          </a>
          <a href="#" className="menu_item is-black w-nav-link">
            Servicios
          </a>
          <a href="#" className="menu_item is-black w-nav-link">
            ¿No tienes cuenta?
          </a>
          <div
            data-delay="0"
            data-hover="false"
            className="menu_drop w-dropdown"
          >
            <div className="menu_drop-toggle w-dropdown-toggle">
              <div className="menu_drop-ico w-icon-dropdown-toggle"></div>
              <div>Trámites</div>
            </div>
            <nav className="menu_droped-list w-dropdown-list">
              <a href="#" className="w-dropdown-link">
                Link 1
              </a>
              <a href="#" className="w-dropdown-link">
                Link 2
              </a>
              <a href="#" className="w-dropdown-link">
                Link 3
              </a>
            </nav>
          </div>
          <div
            data-delay="0"
            data-hover="false"
            className="menu_drop w-dropdown"
          >
            <div className="menu_drop-toggle w-dropdown-toggle">
              <div className="menu_drop-ico w-icon-dropdown-toggle"></div>
              <div>Pagos</div>
            </div>
            <nav className="menu_droped-list w-dropdown-list">
              <a href="#" className="menu_droped-item w-dropdown-link">
                Link 1
              </a>
              <a href="#" className="w-dropdown-link">
                Link 2
              </a>
              <a href="#" className="w-dropdown-link">
                Link 3
              </a>
            </nav>
          </div>
          <div
            data-delay="0"
            data-hover="false"
            className="menu_droped w-dropdown"
          >
          <div className="menu_drop-user w-dropdown-toggle">
              <div className="menu_drop-ico btn w-icon-dropdown-toggle"></div>
              <img loading="lazy" src={Person} alt="" />
              <div>Hola Miguel</div>
            </div>
            <nav className="menu_droped-list w-dropdown-list">
              <a href="#" className="menu_droped-item w-dropdown-link">
                Link 1
              </a>
              <a href="#" className="w-dropdown-link">
                Link 2
              </a>
              <a href="#" className="w-dropdown-link">
                Link 3
              </a>
            </nav>
          </div>
        </div>
        <div className="menu_link-contentmovil">
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Mi perfil</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Planes de salud</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Programas de salud</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Buscador de clínicas</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Sofi</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Teleconsulta</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Constancias y reportes</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Reembolso</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Pagos</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil w-inline-block">
            <div>Botón de emergencia</div>
            <img loading="lazy" src="../images/Vector-2_1.png" alt="" />
          </a>
          <a href="#" className="menu_link-movil cs w-inline-block">
            <div className="menu_link-movil-cont">
              <img loading="lazy" src="../images/salida-1.png" alt="" />
              <div>Cerrar sesión</div>
            </div>
          </a>
        </div>
      </nav>
      <div className="menu_movile is-blanco">
        <div
          data-delay="0"
          data-hover="false"
          className="menu_droped movile w-dropdown"
        >
          <div className="menu_drop-user menu_close-movile w-dropdown-toggle">
            <div className="menu_drop-ico btn w-icon-dropdown-toggle"></div>
            <img
              loading="lazy"
              src="../images/Frame-1.png"
              alt=""
              className="is-ic"
            />
            <div>Hola Miguel</div>
          </div>
          <nav className="menu_droped-list w-dropdown-list">
            <a href="#" className="menu_droped-item w-dropdown-link">
              Link 1
            </a>
            <a href="#" className="w-dropdown-link">
              Link 2
            </a>
            <a href="#" className="w-dropdown-link">
              Link 3
            </a>
          </nav>
        </div>
        <div
          data-w-id="17716f3e-f2c5-624c-665d-98924c7d65de"
          className="menu-button w-nav-button"
        >
          <div className="menu_open-img w-icon-nav-menu"></div>
          <img
            loading="lazy"
            src="../images/Vector_4.png"
            alt=""
            className="menu_close-img"
          />
        </div>
      </div>
    </div>
  );
};

export default NavBarWithoutLogo;
